<srm-quickbet
    [selection]="selection"
    [betslipType]="betslipType"
    [isSRMBet]="isSRMBet"
    [selectedQuestionAndAnswers]="selectedQuestionAndAnswers"
    [srmSelectedChannels]="srmSelectedChannels"
    [srmOdds]="srmOdds"
    [selectionEventLocalTime]="selectionEventLocalTime">
</srm-quickbet>
